import React from 'react';
import {Card, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card';
import Chip from 'material-ui/Chip';

const styles = {
  card:{
    margin:8,
  },
  cardheader:{
    padding:8,
    paddingBottom:0,
  },
  imgStyle:{
  },
  maintext:{
    paddingTop:0,
    paddingBottom:5,
  },
  chip: {
    margin: 4,
    backgroundColor:"rgb(240,240,240)"
  },
  wrapper: {
    display: 'flex',
    flexWrap: 'wrap',
  },
};

export default class ExperienceClingOnGrip extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };
  }

  handleExpandChange = (expanded) => {
    this.setState({expanded: expanded});
  };

  handleToggle = (event, toggle) => {
    this.setState({expanded: toggle});
  };

  handleExpand = () => {
    this.setState({expanded: true});
  };

  handleReduce = () => {
    this.setState({expanded: false});
  };

  render() {
    return (
      <Card
        expanded={this.state.expanded}
        onExpandChange={this.handleExpandChange}
        style={styles.card}
      >
        <CardHeader
          title="Cling-On Grip LLC, Founder/Engineer"
          subtitle="Mobile Device Accessory: 2014-2017"
          avatar="images/clingongrip.jpg"
          actAsExpander={true}
          showExpandableButton={this.props.showCarrot}
          style={styles.cardheader}
        />
        <CardText
          style={styles.maintext}
        >

          <div>
            <ul>
              <li>
                Design, development, assembly, and sales of a mobile device accessory product
              </li>
              <div style={styles.wrapper}>
                <Chip style={styles.chip}>
                  Alibre Solid Modeling
                </Chip>
                <Chip style={styles.chip}>
                  3D Printing (FDM)
                </Chip>
                <Chip style={styles.chip}>
                  Amazon FBA
                </Chip>
              </div>
            </ul>
          </div>

        </CardText>
        <CardMedia
          expandable={true}
          overlay={<CardTitle title="Cling-On Grip" subtitle="" />}
        >
          <img
            src="images/clingongrip_collage.jpg" alt=""
            style={styles.imgStyle}
          />
        </CardMedia>
        <CardText expandable={true}>
          <ul>
            <li>Designed on Alibre solid modeling software</li>
            <li>Prototyped useing 3D printing (FDM)</li>
            <li>The Cling­-On Grip is currently for sale on Amazon.com</li>
          </ul>
        </CardText>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ExperienceClingOnGrip.js